
export default function StreamToEarn() {
  const features = [
    {
      icon: 'ri-coins-fill',
      title: 'PSU Token Rewards',
      description: 'Earn PSU tokens for every hour of quality streaming content',
      value: '10-50 PSU/hour'
    },
    {
      icon: 'ri-trophy-fill',
      title: 'Challenge Bonuses',
      description: 'Complete weekly and monthly challenges for bonus rewards',
      value: '100-500 PSU'
    },
    {
      icon: 'ri-calendar-event-fill',
      title: 'Event Hosting',
      description: 'Host Pump.fun events and earn premium token multipliers',
      value: '2x-5x multiplier'
    },
    {
      icon: 'ri-team-fill',
      title: 'Community Building',
      description: 'Get rewarded for bringing new streamers to the platform',
      value: '200 PSU/referral'
    }
  ];

  const roadmapItems = [
    {
      phase: 'Phase 1',
      title: 'Token Launch',
      status: 'Coming Soon',
      description: 'PSU token deployment and initial distribution',
      color: 'emerald'
    },
    {
      phase: 'Phase 2',
      title: 'Staking System',
      status: 'Q2 2024',
      description: 'Stake PSU tokens for additional rewards and governance',
      color: 'purple'
    },
    {
      phase: 'Phase 3',
      title: 'Marketplace',
      status: 'Q3 2024',
      description: 'Trade exclusive content and merchandise with PSU tokens',
      color: 'emerald'
    }
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-500/5 to-purple-500/5"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-emerald-400 mb-8">
            Stream-to-Earn System
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-400 to-emerald-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            The future of streaming is here. Earn PSU tokens by creating content, joining challenges, and building our community.
          </p>
        </div>

        {/* Earning methods */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="group">
              <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-8 rounded-3xl border border-gray-700/50 hover:border-emerald-500/30 transition-all duration-300 hover:transform hover:scale-105 h-full">
                <div className="w-16 h-16 bg-gradient-to-br from-emerald-500/20 to-purple-500/20 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${feature.icon} text-2xl text-emerald-400`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
                <p className="text-gray-300 text-sm mb-4 leading-relaxed">{feature.description}</p>
                
                <div className="bg-emerald-500/10 px-4 py-2 rounded-full border border-emerald-500/20">
                  <span className="text-emerald-400 font-bold text-sm">{feature.value}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          <div className="flex items-center justify-between p-4 bg-purple-500/10 rounded-2xl border border-purple-500/20">
            <div>
              <span className="text-gray-300 text-sm">Active Streamers</span>
              <div className="text-2xl font-bold text-purple-400">247</div>
            </div>
            <i className="ri-live-fill text-3xl text-purple-400"></i>
          </div>
        </div>

        {/* Roadmap only */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-gradient-to-br from-slate-800/30 to-slate-900/30 rounded-3xl p-8 border border-gray-700/30">
            {/* Fixed mismatched heading tags */}
            <h3 className="text-3xl font-bold text-white mb-6">Roadmap</h3>
            
            <div className="space-y-6">
              {roadmapItems.map((item, index) => (
                <div key={index} className="relative">
                  <div className={`p-6 rounded-2xl bg-gradient-to-r ${item.color === 'emerald' ? 'from-emerald-500/10 to-emerald-600/10 border border-emerald-500/20' : 'from-purple-500/10 to-purple-600/10 border border-purple-500/20'}`}>
                    <div className="flex items-center justify-between mb-3">
                      <span className={`text-sm font-bold px-3 py-1 rounded-full ${item.color === 'emerald' ? 'bg-emerald-500/20 text-emerald-400' : 'bg-purple-500/20 text-purple-400'}`}>
                        {item.phase}
                      </span>
                      <span className="text-xs text-gray-400 font-medium">{item.status}</span>
                    </div>
                    <h4 className="text-xl font-bold text-white mb-2">{item.title}</h4>
                    <p className="text-gray-300 text-sm">{item.description}</p>
                  </div>
                  
                  {index < roadmapItems.length - 1 && (
                    <div className="absolute left-6 -bottom-3 w-0.5 h-6 bg-gradient-to-b from-emerald-500/50 to-purple-500/50"></div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
